module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "landing-footer"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('nav', {
    staticClass: "site-nav row d-md-flex"
  }, [_c('div', {
    staticClass: "col d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.company-value.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.talents.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility.title')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.rd.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.global-presence.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration.title')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#ruyi-brand-network'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#smcp'
      }
    }
  }, [_vm._v("SMCP")]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#renown'
      }
    }
  }, [_vm._v("RENOWN")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#green-energy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-01.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#powering-future'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-02.title')))]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "site-nav-link site-nav-link-primary",
    on: {
      "click": _vm.showSitemapOverlay
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sitemap.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))])], 1), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))]), _vm._v(" "), _c('address', {
    staticClass: "ruyi-address d-md-none",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('widgets.footer-address'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brand mb-md-4 mb-xl-5"
  }, [_c('img', {
    staticClass: "ruyi-logo",
    attrs: {
      "src": require("@/assets/images/logos/ruyi.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ruyi-group d-block mx-auto mx-md-0"
  }, [_vm._v(_vm._s(_vm.$t('common.ruyi-group2')))])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "follow-us"
  }, [_c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibo"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wechat"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-752b3202","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LandingFooter.vue
// module id = 630
// module chunks = 1